// import { useTranslation } from "react-i18next";
// import { useStrapiFetch } from "../../hooks/use-strapi-fetch";
// import type { CateringType } from "../../types/common";
import { Markdown } from "../../components/common/markdown";

export function CateringPage() {
	// const { t, i18n } = useTranslation();
	// const { data } = useStrapiFetch<CateringType>("/api/catering?populate=image");

	// if (!data) {
	// 	return null;
	// }

	// const { titlePL, titleEN, descriptionPL, descriptionEN } = data.attributes;

	// i18n.addResourceBundle(
	// 	"pl",
	// 	"translation",
	// 	{ catering: { title: titlePL, description: descriptionPL } },
	// 	true,
	// 	true
	// );

	// i18n.addResourceBundle(
	// 	"en",
	// 	"translation",
	// 	{ catering: { title: titleEN, description: descriptionEN } },
	// 	true,
	// 	true
	// );

	return (
		<main>
			<div className="relative w-full max-w-[1200px] mx-auto px-[15px] py-7 md:py-9">
				<img
					src="https://cms.mlecznebary.pl/uploads/image009_2128588dd6.png"
					alt=""
					className="object-contain"
				/>

				<h1 className="font-semibold text-[#002969] text-xl sm:text-2xl md:text-3xl text-center">
					Oferta cateringu zewnętrznego
				</h1>
				<Markdown className="my-4">
					{
						"**Tradycyjna polska kuchnia na Twoim wydarzeniu** \n\nOd lat prowadzimy bary mleczne z domowym, polskim jedzeniem. Teraz tę samą jakość, smak i doświadczenie przenosimy wprost na Twoje wydarzenie – dzięki nowej usłudze **cateringu zewnętrznego**."
					}
				</Markdown>
				<h3 className="font-semibold text-[#002969] text-xl sm:text-2xl md:text-3xl text-center">
					Co oferujemy?
				</h3>
				<Markdown className="my-4">
					{
						"Kompleksowy catering na: \n\n-	🎉 **Imprezy okolicznościowe** \n\nwesela, chrzciny, komunie, urodziny, jubileusze, spotkania rodzinne \n\n-	🏢 **Catering korporacyjny** \n\nspotkania biznesowe, konferencje, szkolenia, eventy firmowe, imprezy integracyjne \n\n-	🏫 **Catering dla instytucji publicznych** \n\nszkoły, przedszkola, uczelnie, ośrodki kultury – dni otwarte, akademie, konferencje, pikniki \n\n-	🏛️ **Catering dla urzędów, fundacji i stowarzyszeń** \n\nkonferencje prasowe, warsztaty, spotkania projektowe, wydarzenia promocyjne \n\n-	🎪 **Obsługa wydarzeń masowych** \n\nkoncerty, festiwale, targi, wystawy, wydarzenia sportowe, eventy miejskie i gminne"
					}
				</Markdown>
				<h3 className="font-semibold text-[#002969] text-xl sm:text-2xl md:text-3xl text-center">
					Charakter kuchni
				</h3>
				<Markdown className="my-4">
					{
						"Specjalizujemy się w **tradycyjnej kuchni polskiej**, opartej na: \n\n- sprawdzonych, domowych przepisach, \n\n- prostych, naturalnych składnikach, \n\n- daniach lubianych przez gości w każdym wieku. \n\nW ofercie m.in.: \n\npierogi, naleśniki, kluski śląskie, pyzy, dania mięsne, zupy, dodatki warzywne, sałatki oraz desery w stylu domowym. \n\nMenu każdorazowo dopasowujemy do typu wydarzenia, pory dnia, liczby gości oraz budżetu."
					}
				</Markdown>
				<h3 className="font-semibold text-[#002969] text-xl sm:text-2xl md:text-3xl text-center">
					Jak działamy? – krok po kroku
				</h3>
				<Markdown className="my-4">
					{
						"1. **Kontakt i zapytanie** \n\n Możesz skontaktować się z nami: \n\n -	osobiście w jednym z naszych barów mlecznych, \n\n \n Bar Mleczny Mleczarnia, ul. E. Plater 47 \n\n Bar Mleczny Mleczarnia, ul. Nowowiejska 6 \n\n Bar Mleczny Mleczarnia, ul. Ostrobramska 75c – Promenada \n\n Bar Mleczny Mleczarnia, ul. Grażyny 1 \n\n Bar Mleczny Mleczarnia, ul. Powsińska 27 \n\n Bar Mleczny Mleczarnia, ul. Freta 17 \n\n - telefonicznie: 660-405-132, \n\n - mailowo: konrad@mleczaki.pl. \n\n 2. **Ustalenie szczegółów** \n\n Wspólnie doprecyzujemy: \n\n - charakter wydarzenia, \n\n - liczbę gości, \n\n - preferencje żywieniowe (w tym opcje wegetariańskie), \n\n - propozycje menu, \n\n - termin i miejsce dostawy, \n\n - zakres dodatkowych usług (np. obsługa, serwis). \n\n 3. **Przygotowanie oferty** \n\n Na podstawie ustaleń przygotujemy dopasowaną ofertę cateringową – od prostych, domowych posiłków po rozbudowane zestawy na duże eventy. \n\n 4. **Przygotowanie potraw** \n\n Wszystkie dania przygotowywane są w **nowoczesnym, wydajnym zapleczu kuchennym**, przystosowanym do pracy przy dużych wolumenach zamówień. \n\n 5. **Pakowanie i transport** \n\n - potrawy są odpowiednio zapakowane (z dbałością o bezpieczeństwo żywności i jakość), \n\n - przygotowane do transportu i wydania na miejscu wydarzenia, \n\n - dostarczane w terminie i pod wskazany adres."
					}
				</Markdown>
				<h3 className="font-semibold text-[#002969] text-xl sm:text-2xl md:text-3xl text-center">
					Obsługa dużych wydarzeń
				</h3>
				<Markdown className="my-4">
					{
						"Nasze nowe zaplecze kuchenne zostało zaprojektowane tak, aby: \n\n- przygotowywać **duże ilości posiłków w krótkim czasie**, \n\n- jednocześnie utrzymać wysoką jakość i powtarzalność dań, \n\n- zapewnić sprawne pakowanie i przygotowanie do transportu, \n\n- nie obciążać bieżące j pracy barów mlecznych. \n\n Dzięki temu możemy równolegle: \n\n- **prowadzić dotychczasową działalność gastronomiczną w barach mlecznych**, \n\n- oraz **świadczyć usługi cateringu zewnętrznego** na dużą skalę."
					}
				</Markdown>
				<h3 className="font-semibold text-[#002969] text-xl sm:text-2xl md:text-3xl text-center">
					Dania pakowane próżniowo – na wynos
				</h3>
				<Markdown className="my-4">
					{
						"W ramach rozbudowy naszego zaplecza kuchennego wprowadzamy także **sprzedaż świeżych dań pakowanych próżniowo**, m.in.: \n\n- porcje pierogów, \n\n- naleśniki, \n\n- pyzy, \n\n- kluski śląskie i inne dania kuchni polskiej. \n\n Dostępne będą one: \n\n- w specjalnie przygotowanych witrynach, \n\n- zarówno dla klientów barów mlecznych, \n\n- jak i klientów z zewnątrz. \n\n To idealne rozwiązanie dla osób, które chcą: \n\n- mieć pod ręką **świeże, domowe jedzenie**, \n\n- szybko przygotować posiłek w domu, \n\n- zabrać ze sobą gotowe dania do pracy lub na wyjazd."
					}
				</Markdown>
				<h3 className="font-semibold text-[#002969] text-xl sm:text-2xl md:text-3xl text-center">
					Dlaczego warto wybrać nasz catering?
				</h3>
				<Markdown className="my-4">
					{
						"- ✅ **Wieloletnie doświadczenie** w prowadzeniu barów mlecznych z tradycyjną kuchnią polską \n\n- ✅ **Własne, nowoczesne zaplecze kuchenne** przystosowane do dużych zleceń \n\n- ✅ **Kompleksowa obsługa** – od ustalenia menu po dostawę na miejsce wydarzenia \n\n- ✅ **Elastyczność** – dopasowujemy menu i formę podania do charakteru imprezy \n\n- ✅ **Różne typy klientów** – obsługujemy zarówno osoby prywatne, jak i firmy, instytucje, organizatorów wydarzeń masowych \n\n- ✅ **Bezpieczeństwo i jakość** – odpowiednie pakowanie, transport i warunki przechowywania"
					}
				</Markdown>
				<h3 className="font-semibold text-[#002969] text-xl sm:text-2xl md:text-3xl text-center">
					Jak zamówić catering?
				</h3>
				<Markdown className="my-4">
					{
						"Skontaktuj się z nami, aby otrzymać indywidualną wycenę: \n\n- odwiedź nas w jednym z naszych barów mlecznych, \n\n- zadzwoń, aby omówić szczegóły, \n\n- wyślij maila z informacją o rodzaju wydarzenia, liczbie gości i terminie. \n\n Przygotujemy dopasowaną ofertę cateringu, dzięki której Twoje wydarzenie będzie nie tylko udane organizacyjnie, ale też… **pyszne**. 🍲🥟"
					}
				</Markdown>
			</div>
		</main>
	);
}
